/**
 * @file  signature/index.ts
 * @description  signature service to handle the signature process
 *
 * @author ogarcia (ozkary)
 *
 */

/**
 * Imports.
 */
import * as _cache from '../cache';
import * as _datetime from '../datetime';
import { digitalSignature } from '../../services/settings';
import Signature from './model';

const sigKey = _cache.Key.signature;

// get the digital signature. can override by adding a setting on the json rates file
const signatureData = digitalSignature || 'Electronically Acknowledged by ';

/**
 * gets the current signature
 * @returns the digital signature
 */
export const get = (): Signature => {
  const signature: Signature = _cache.getItem<Signature>(sigKey);
  return signature;
};

/**
 * removes the signature from the cache
 */
export const clear = (): void => {
  _cache.removeItem(sigKey);
};

/**
 * sets a digital signature
 * @param firstnName first name
 * @param lastName last name
 * @returns the signature element
 */
export const set = (firstnName: string, lastName: string): Signature => {
  const initial = `${
    firstnName?.charAt(0)?.toUpperCase() + lastName?.charAt(0)?.toUpperCase()
  }`;
  const fullName = `${firstnName} ${lastName}`;
  const data = signatureData + fullName;
  const created = _datetime.now() as Date;
  const agree = true;

  const signature: Signature = {
    initial,
    created,
    data,
    agree
  };

  _cache.setItem<Signature>(sigKey, signature);

  return signature;
};

/**
 * indicates if agree term is checked
 * @returns the agree term flag
 */
export const getAgreeTerm = async (): Promise<boolean> => {
  const sign = get();

  if (sign && sign.agree) {
    return true;
  }

  return false;
};
